import { render, staticRenderFns } from "./ImportMail.vue?vue&type=template&id=3596875d"
import script from "./ImportMail.vue?vue&type=script&lang=js"
export * from "./ImportMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3596875d')) {
      api.createRecord('3596875d', component.options)
    } else {
      api.reload('3596875d', component.options)
    }
    module.hot.accept("./ImportMail.vue?vue&type=template&id=3596875d", function () {
      api.rerender('3596875d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/ImportMail.vue"
export default component.exports